import React, { useEffect, useRef, useState } from "react";
import { IoChevronBackSharp, IoChevronForwardSharp } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";
import { Button, Input, HStack, Text } from '@chakra-ui/react';

import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/web/pdf_viewer.css";

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.mjs`;

interface ExtendedDocumentPreviewProps {
    fileUrl: string;
}

const ExtendedDocumentPreview: React.FC<ExtendedDocumentPreviewProps> = ({ fileUrl }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const [pdf, setPdf] = useState<pdfjsLib.PDFDocumentProxy | null>(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [renderTask, setRenderTask] = useState<pdfjsLib.RenderTask | null>(null);

    useEffect(() => {
        const loadPdf = async () => {
            try {
                const pdfDoc = await pdfjsLib.getDocument(fileUrl).promise;
                setPdf(pdfDoc);
                setTotalPages(pdfDoc.numPages);
            } catch (error) {
                console.error("Errore while loading preview: ", error);
            }
        };

        loadPdf();
    }, [fileUrl]);

    const renderPage = async (pageNum: number) => {
        if (!pdf || !canvasRef.current) return;

        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 2 });

        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        if (!context) return;

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const renderContext = {
            canvasContext: context,
            viewport: viewport,
        };

    
        if (renderTask) {
            renderTask.cancel();
        }

        const task = page.render(renderContext);
        setRenderTask(task);

        try {
            await task.promise;
        } catch (error) {
        }
    };

    useEffect(() => {
        if (pdf) {
            renderPage(currentPage);
        }
    }, [pdf, currentPage]);

    const downloadPdf = () => {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileUrl.split("/").pop() || "preview.pdf";
        link.click();
    };


    return (
        <div style={{ width: "100%", textAlign: "center" }}>
            <HStack className="pdf-viewer-toolbar">
                <HStack spacing={2}>
                    <Button
                        className="el-btn pdf-viewer-btn"
                        onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                        isDisabled={currentPage === 1}
                    >
                        <IoChevronBackSharp />
                    </Button>
                    <Input
                        className="pdf-page-input"
                        type="number"
                        value={currentPage}
                        onChange={(e) => {
                            const pageNum = parseInt(e.target.value, 10);
                            if (pageNum > 0 && pageNum <= totalPages) setCurrentPage(pageNum);
                        }}
                        min={1}
                        max={totalPages}
                        width="45px"
                        textAlign="center"
                    />
                    <Text>of {totalPages}</Text>
                    <Button
                        className="el-btn pdf-viewer-btn"
                        onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
                        isDisabled={currentPage === totalPages}
                    >
                        <IoChevronForwardSharp />
                    </Button>
                </HStack>
                <Button
                    leftIcon={<FiDownload />}
                    className="el-btn"
                    onClick={downloadPdf}
                    size="sm"
                >
                    Download Work Order preview
                </Button>
            </HStack>

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    overflow: "hidden",
                    border: "1px solid #000",
                }}
            >
                <canvas
                    ref={canvasRef}
                    style={{
                        width: "100%",
                        maxWidth: "800px",
                        background: "#fff",
                        display: "block",
                    }}
                />
            </div>
        </div>
    );
};

export default ExtendedDocumentPreview;








